import { render, staticRenderFns } from "./joinin-dialog.vue?vue&type=template&id=0daa613a&scoped=true"
import script from "./joinin-dialog.vue?vue&type=script&lang=js"
export * from "./joinin-dialog.vue?vue&type=script&lang=js"
import style0 from "./joinin-dialog.vue?vue&type=style&index=0&id=0daa613a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daa613a",
  null
  
)

export default component.exports